import { useState } from 'react';

var useTooltip = () => {
  var [focus, setFocus] = useState(false);

  var focused = () => setFocus(true);

  var blurred = () => setFocus(false);

  return {
    focus,
    focused,
    blurred
  };
};

export { useTooltip };
//# sourceMappingURL=useTooltip.js.map